/**
 * The mutation result holds the necessary data that extract from the fetch response.
 */
export class GraphQlMutationResult {
  constructor(code, reason, response) {
    this.code = code;
    this.reason = reason;
    this.response = response;
  }
}
class MutationResultCreator {}

/**
 * This class is responsible for creating a mutation result for a non-OK fetch response.
 */
export class NonOkMutationResultCreator extends MutationResultCreator {
  constructor(fetchResponse) {
    super();
    this.fetchResponse = fetchResponse;
  }
  makeMutationResult() {
    return new GraphQlMutationResult(this.fetchResponse.status, this.fetchResponse.statusText);
  }
}

/**
 * This class is responsible for creating a mutation result for a fetch response that contains general errors.
 */
export class GeneralMutationErrorResultCreator extends MutationResultCreator {
  constructor(errors) {
    super();
    this.errors = errors;
  }
  makeMutationResult() {
    const [{
      extensions
    }] = this.errors;
    const [{
      statusCode,
      errorType
    }] = Array.isArray(extensions) ? extensions : [extensions];
    return new GraphQlMutationResult(statusCode, errorType, {
      errors: this.errors.map(error => error.message)
    });
  }
}

/**
 * This class is responsible for creating a mutation result for a fetch response that missing the key attributes.
 */
export class MissingMutationDataResultCreator extends MutationResultCreator {
  constructor(fetchResponse) {
    super();
    this.fetchResponse = fetchResponse;
  }
  makeMutationResult() {
    return new GraphQlMutationResult(this.fetchResponse.status, this.fetchResponse.statusText, {
      errors: ['Received data has missing attributes']
    });
  }
}

/**
 * This class is responsible for creating a mutation result for a fetch response that contains mutation errors.
 */
export class MutationErrorResultCreator extends MutationResultCreator {
  constructor(mutationResponse) {
    super();
    this.mutationResponse = mutationResponse;
  }
  makeMutationResult() {
    const {
      errors
    } = this.mutationResponse;

    // This is meant to be a runtime error during development.
    if (!Array.isArray(errors) || !errors.length) {
      // The error is not expected to happen inside this function.
      throw new Error('Invalid mutation response: missing errors');
    }

    // This is a safe assertion because we already checked that the response contains errors.
    const [{
      extensions: {
        statusCode,
        errorType
      }
    }] = errors;
    return new GraphQlMutationResult(statusCode, errorType, {
      errors: errors.map(error => error.message)
    });
  }
}
export class MutationSuccessResultCreator extends MutationResultCreator {
  constructor(response, mutationResponse) {
    super();
    this.response = response;
    this.mutationResponse = mutationResponse;
  }
}